import { IMetaCardConfig } from "../../../component/zComponents/CustomizedMetaCard/CustomizedMetaCard.d";
import { ITabsViewConfig, ITabsComponentFilter } from "./tabs-component/TabsComponent.d";

export interface IDetailedViewProps {
	orderShippableId: string;
	onBackButton: () => void;
}

export interface IDetailViewState {
	styles: Array<IDetailViewStyle>;
	activeStyleIndex: number;
	lastSyncTime: Date;
}

export interface IDetailViewStyle {
	displayName: string;
	key: string;
	components: Array<IDetailViewComponent>;
}

export interface IDetailViewComponent {
	id: string;
	type: TDetailViewComponentType;
	config: ITabsViewConfig | IMetaCardConfig;
	data: any;
	filters: Array<ITabsComponentFilter>;
}

export type TDetailViewComponentType = 'META_CARD' | 'XY_CHART_TABS';

export type TDetailViewPayload = IDetailViewInitPayload;

export enum DetailViewAction {
	INIT_STATE = 'INIT_STATE'
}
export interface IDetailViewInitPayload {
	state: IDetailViewState;
}

export interface IDetailViewActionProps {
	type: DetailViewAction;
	payload: TDetailViewPayload;
}

export interface IDetailViewLayoutResponse {
	// styles: Array<IStyleResponse>;
	components: Array<IDetailViewComponentResponse>;
}

export interface IStyleResponse {
	key: string;
	displayName: string;
}
export interface IDetailViewComponentResponse {
	id: string;
	config: { option: ITabsViewConfig | IMetaCardConfig };
	filterDTOS?: Array<{ key: string, multiSelection: boolean, displayValue: string }>;
	type: TDetailViewComponentType;
}

